export default "__VITE_ASSET__Bkih93qn__"